// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rdcRCfF6{gap:max(2rem,min(2.08vw,2.5rem));padding-top:max(1rem,min(1.25vw,1.5rem))}.rdcRCfF6,.-fTzw\\+4v{display:flex;flex-direction:column}.-fTzw\\+4v{gap:max(2.5rem,min(3.13vw,3.75rem))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"container": "rdcRCfF6",
	"content": "-fTzw+4v"
};
module.exports = ___CSS_LOADER_EXPORT___;
